import {createPopper, Instance} from "@popperjs/core";
import {IServiceFactory} from "../../services/service-factory.interface";
import {ResizeObserver} from "@juggle/resize-observer";
import {IReactionDisposer, reaction} from "mobx";

export const DROP_DOWN_POPPER_ANCHOR_ELEMENT_ID = 'drop-down-popper-anchor';

export class PopperDropDownModel {
    constructor(private readonly _elementToAttach: HTMLElement,
                private readonly _elementToShow: HTMLElement,
                private readonly services: IServiceFactory) {
        this._popperResizeObserver = new ResizeObserver(this._onPopperResize);
        this._popperResizeObserver.observe(_elementToShow);
        this._popperInstance = this._createPopperInstance();
        this._reactions.push(reaction(() => [this.services.application.isInMobileView],
            () => {
                this._popperInstance.destroy();
                this._popperInstance = this._createPopperInstance();
            }));


        this._reactions.push(reaction(() => [this.services.application.originalHeight],
            () => {
                this._popperInstance.forceUpdate();
            }));

    }

    private _reactions: IReactionDisposer[] = [];

    private _createPopperInstance() {
        return createPopper(this.elementToAttach, this._elementToShow, {
            placement: 'bottom-start',
            modifiers: [
                {
                    name: "sameWidthAsAttachedElement",
                    enabled: true,
                    fn: ({ state }) => {
                        const popperStyle = state.styles.popper
                        if(this.services.application.isInMobileView) {
                            popperStyle.top = '0px';
                            popperStyle.left = '0px';
                            popperStyle.width = `100%`;
                            popperStyle.height = `500px`;
                            popperStyle.position = 'fixed';
                        } else {
                            popperStyle.width = `${state.rects.reference.width}px`;
                        }
                    },
                    phase: "beforeWrite",
                    requires: ["computeStyles"],
                },
                {
                    name: "sendResizePostMessage",
                    enabled: true,
                    phase: "afterWrite",
                    fn: () => {
                        this._sendContentResized();
                    }
                }
            ]
        });
    }

    private get elementToAttach(): HTMLElement {
        if(this.services.application.isInMobileView) {
            const el = document.getElementById(DROP_DOWN_POPPER_ANCHOR_ELEMENT_ID);
            if(el) {
                return el;
            }
        }

        return this._elementToAttach;
    }

    private readonly _popperResizeObserver: ResizeObserver;
    private _sendContentResized(): void {
        this.services.application.setCustomHeight(this._computeNewWindowHeight());
    }

    private _popperInstance: Instance;
    private _onPopperResize = () => {
        this._sendContentResized();
    }

    private _computeNewWindowHeight(): number {
        const rect = this._elementToShow.getBoundingClientRect();
        return rect.top + rect.height;
    }

    dispose(): void {
        this._popperResizeObserver.disconnect();
        this._popperInstance.destroy();
        this.services.application.restoreOriginalHeight();
        this._reactions.forEach(r => r());
    }
}
